import React, { useState, useCallback, useEffect } from 'react';
import { TextField, Button } from '@mui/material';
import DataObjectIcon from '@mui/icons-material/DataObject';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { NodeHead, NodeHandle, useNodeStyles } from './nodeKit';

const VariableNode = React.memo(({ data, id }) => {

  const [variableName, setVariableName] = useState(data.variableName || '');
  const [variableValue, setVariableValue] = useState(data.variableValue || '');
  const [variableType, setVariableType] = useState(data.variableType || 'text');
  const [savedStatus, setSavedStatus] = useState(data.savedStatus || '');
  const [showSavePopup, setShowSavePopup] = useState(false);
  

  const classes = useNodeStyles();


  useEffect(() => {
   
    data.variableName = variableName;
    data.variableValue = variableValue;
    data.variableType = variableType;
    data.savedStatus = savedStatus;
  }, [variableName, variableValue, variableType, savedStatus, data]);
  

  useEffect(() => {
    let timer;
    if (showSavePopup) {
      timer = setTimeout(() => {
        setShowSavePopup(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showSavePopup]);


  const handleSave = useCallback(() => {
   
    if (variableName) {

      window.flowVariables = window.flowVariables || {};
      

      window.flowVariables[variableName] = variableValue;
      

      setSavedStatus('Salvo!');
      setShowSavePopup(true);
      

    }
  }, [variableName, variableValue, data]);

  return (
    <div className={`${classes.root} kp-flow-node`} style={{ width: 280 }}>
      <NodeHandle type="target" id="variable-in" />
      <NodeHead color="#1976d2" icon={<DataObjectIcon />} title="Variável Global" id={id} />

      <div className={`${classes.body} nodrag`} style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 4 }}>
        <TextField
          label="Nome da variável"
          size="small"
          value={variableName}
          onChange={(e) => setVariableName(e.target.value)}
          fullWidth
        />

        <TextField
          label="Valor"
          size="small"
          value={variableValue}
          onChange={(e) => setVariableValue(e.target.value)}
          fullWidth
          multiline
          minRows={2}
          maxRows={4}
          helperText="Você pode usar valores estáticos ou referências como ${outraVariavel}"
        />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
          <span className={savedStatus === 'Salvo!' ? classes.savedOk : classes.hint} style={{ marginTop: 0 }} role="status">
            {showSavePopup ? 'Variável salva com sucesso!' : savedStatus}
          </span>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSave}
            startIcon={<CheckCircleOutlineIcon />}
          >
            Salvar variável
          </Button>
        </div>
      </div>

      <NodeHandle type="source" id="variable-out" />
    </div>
  );
});

export default VariableNode;


export const getFlowVariable = (name) => {
  if (!window.flowVariables) {

    return undefined;
  }
  return window.flowVariables[name];
};


export const setFlowVariable = (name, value) => {
  if (!window.flowVariables) {

    window.flowVariables = {};
  }
  

  window.flowVariables[name] = value;
  

  const event = new CustomEvent('flowVariableUpdate', { 
    detail: { name, value } 
  });
  window.dispatchEvent(event);
  

  return value;
};